import React from 'react'
import {observer} from 'mobx-react'
import {Box, Flex, Stack, Text} from '../../../vanilla'
import { OfferCard } from './OfferCard'
import { OfferCardsCmsContent } from '../../../types/cms'
import {SlotComponent} from '../../../types/ui'
import {Carousel} from '../../carousel'
import {offerCardList, offerCardTitle} from './styles.css'

export const OfferCards: SlotComponent<OfferCardsCmsContent> = observer(({content, slotGroupName, slotIndex}) => {
  const {cardList = [], isMobileCarousel, title, campaign} = content
  
  // Early return if no cards to display
  if (!cardList.length) return null
  
  const showDesktopView = cardList.length === 1 || !isMobileCarousel

  return (
    <Box>
      {/* Title Section */}
      {title && (
        <Stack align="stretch" marginY="10px">
          <Flex>
            <Text
              className={offerCardTitle}
              textAlign="center"
              marginTop="10px"
              marginBottom={["10px", "20px"]}
              width="full"
            >
              {title}
            </Text>
          </Flex>
        </Stack>
      )}
      {/* Desktop View - Row of Cards */}
      <Box
        flexDirection={['column', 'row']}
        display={showDesktopView ? 'flex' : ['none', 'flex']}
        width="full"
        gap={["10px", "20px"]}
        className={offerCardList}
      >
        {cardList?.map((card, index) => {
          return (
            <OfferCard
              key={card._meta.deliveryId}
              content={card}
              styles={{width: '100%', height: 'auto'}}
              size={cardList.length}
              index={index + 1}
              isOfferCards={true}
              offerCardsSlotGroupName={slotGroupName as string}
              slotIndex={slotIndex as number}
              campaign={campaign}
            />
          )
        })}
      </Box>
      {/* Mobile View - Carousel */}
      <Box display={showDesktopView ? 'none' : ['block', 'none']}>
        <Carousel
          loop={false}
          className="offer-cards-carousel"
          itemsPerSide={{desktop: 1, mobile: 1, tablet: 1}}
          controlsPosition="bottom"
          controlConfig={{
            activeDotColor: 'accent0',
            arrowsBgColor: 'gray600',
            arrowsColor: 'white',
            dotsOutline: true,
            showArrows: {mobile: false, desktop: true, tablet: true},
          }}
        >
          {cardList?.map((card, index) => {
            return (
              <OfferCard
                key={card._meta.deliveryId}
                content={card}
                styles={{width: '100%', height: 'auto', flexShrink: 0}}
                index={index + 1}
                isOfferCards={true}
                offerCardsSlotGroupName={slotGroupName as string}
                slotIndex={slotIndex as number}
                campaign={campaign}
              />
            )
          })}
        </Carousel>
      </Box>
    </Box>
  )
})
